import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { createThemeObject, codesandboxLightTheme } from "../themes";
import { injectThemeStyleSheet } from "../utils/domUtils";
const SandpackThemeContext = React.createContext({
    theme: codesandboxLightTheme,
    id: "codesandbox-light",
});
const SandpackThemeProvider = (props) => {
    const { theme, id } = createThemeObject(props.theme);
    const c = useClasser("sp");
    // If theme is not explicitly set, don't inject any stylesheet
    if (props.theme) {
        injectThemeStyleSheet(theme, id);
    }
    return (React.createElement(SandpackThemeContext.Provider, { value: {
            theme,
            id,
        } },
        React.createElement("div", { className: c("wrapper", id) }, props.children)));
};
const SandpackThemeConsumer = SandpackThemeContext.Consumer;
export { SandpackThemeProvider, SandpackThemeConsumer, SandpackThemeContext };
//# sourceMappingURL=themeContext.js.map